<div class="modal-header">
	<h5 class="modal-title">{{label || name}}</h5>
	<button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
</div>
<div class="modal-body">
	<textarea
		class="form-control"
		[(ngModel)]="value"
		rows="10"
		[readonly]="readonly"
	></textarea>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-outline-secondary btn-sm" (click)="onCancel()">Abbrechen</button>
	<button *ngIf="!readonly" type="button" class="btn btn-primary btn-sm" (click)="onSave()">Speichern</button>
</div>
